import React, { FC } from 'react'
import { Modal, Tabs } from 'antd'
import { UserInviteFormValues } from '../../types'
import { useBreakpoints } from '../../components'
import InviteForm from '../../components/InviteForm'

interface CreateUserModalProps {
	isVisible: boolean
	create(values: UserInviteFormValues): Promise<void>
	close(): void
}

const CreateInviteModal: FC<CreateUserModalProps> = ({ create, close, isVisible }) => {
	const breakpoints = useBreakpoints()
	return (
		<>
			<Modal centered={breakpoints.md} destroyOnClose footer={null} visible={isVisible} onCancel={close} title={`Create User`}>
				<Tabs defaultActiveKey='service_provider'>
					<Tabs.TabPane tab="Service Provider" key="service_provider">
						<InviteForm type='service_provider' submit={create} />
					</Tabs.TabPane>
					<Tabs.TabPane tab="Reseller" key="reseller">
						<InviteForm type='reseller' submit={create} />
					</Tabs.TabPane>
				</Tabs>
			</Modal>
		</>
	)
}

export default CreateInviteModal
